<script>
import SidebarDropdown from '@wielink-application/shared/vue/layouts/partials/sidebar-dropdown.vue'
export default SidebarDropdown;
</script>